import store from '@/store';

const state = {
    selectedOrgFilter : null,
    selectedImportState: null
}

const getters = {
    selectedOrgState: state => state.selectedOrgFilter,
    selectedImportState: state => state.selectedImportState
}

const mutations = {
    updateOrgFilter(state, currentOrg) {
        state.selectedOrgFilter =  currentOrg
    },
    clearOrgFilter(state) {
        state.selectedOrgFilter = null;
    },
    updateImportState(state, currentState) {
        state.selectedImportState = currentState;
    },
    clearImportState(state) {
        state.selectedImportState = null;
    }

}

const actions = {
    saveOrgFilter({commit, state}, selectedOrg)
    {
        commit('updateOrgFilter', selectedOrg);
    },
    clearOrgFilter({commit, state})
    {
        commit('clearOrgFilter');
    },
    saveImportState({commit, state}, selectedImportState)
    {
        commit('updateImportState', selectedImportState);
    },
    clearImportState({commit, state})
    {
        commit('clearImportState');
    }
}

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
};